// @ts-nocheck
import { DropDownFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { blockMarginOptions } from "@store/Library/Components/Toolkit/Block/Block";
import { getDataOptionsFieldDefinition } from "@toolkit/Framework/Common/Utilities/dataOptions";

const blockMarginField = {
    ...getDataOptionsFieldDefinition(blockMarginOptions),
    displayName: "Spacing",
} as DropDownFieldDefinition<string>;

export default blockMarginField;
